import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getHelpList as _getHelpList } from '@/api/home';
export default {
  name: 'QuickHelp',
  data: function data() {
    return {
      showQuickHelpList: false,
      countDown: null,
      helpList: []
    };
  },
  created: function created() {
    this.getHelpList();
  },
  methods: {
    getHelpList: function getHelpList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, _yield$_getHelpList, status, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  codes: ['C0014'],
                  param: {
                    code: 'C0008'
                  }
                };
                _context.next = 3;
                return _getHelpList(params);

              case 3:
                _yield$_getHelpList = _context.sent;
                status = _yield$_getHelpList.status;
                data = _yield$_getHelpList.data;

                if (!(status !== 1)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                _this.helpList = JSON.parse(data[0].content); // 保存一下默认链接

                if (_this.helpList.length) {
                  localStorage.setItem('helpCenterUrl', _this.helpList[0].url);
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    changeHelpList: function changeHelpList() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.showQuickHelpList = typeof bool === 'boolean' ? bool : false;
    },
    gotoHelpCenter: function gotoHelpCenter(url) {
      // 取默认链接
      if (!url) {
        url = localStorage.getItem('helpCenterUrl');
      }

      var routeUrl = this.$router.resolve({
        name: 'helpCenter',
        query: {
          url: url
        }
      });
      window.open(routeUrl.href, '_blank');
    }
  }
};